import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { useNewsAgenda } from "scmp-app/components/plus/news-agenda/hooks";
import type { headPlusNewsAgendaRightHeadTopic$key } from "scmp-app/queries/__generated__/headPlusNewsAgendaRightHeadTopic.graphql";

import {
  Container,
  Contents,
  Date,
  DateRange,
  DayWrapper,
  DescriptionWrapper,
  Month,
  SecondaryDescription,
  Separator,
  Time,
  Title,
} from "./styles";

export type Props = {
  reference: headPlusNewsAgendaRightHeadTopic$key;
};

export const PlusNewsAgendaRightHead: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const topic = useFragment(
    graphql`
      fragment headPlusNewsAgendaRightHeadTopic on Topic {
        name
        newsAgenda {
          secondaryDescription
        }
        ...hooksNewsAgendaTopic
      }
    `,
    reference_,
  );

  const { date, day, month, time } = useNewsAgenda(topic);

  return (
    <Container>
      <DayWrapper>
        <Date>{day}</Date>
        <Month>{month}</Month>
      </DayWrapper>
      <Contents>
        <Title>{topic.name}</Title>
        <DescriptionWrapper>
          {date && (
            <>
              <DateRange>{date}</DateRange>
              {time && (
                <>
                  <Separator>|</Separator>
                  <Time>{time}</Time>
                </>
              )}
            </>
          )}
          {topic.newsAgenda?.secondaryDescription && (
            <>
              {date && <Separator>|</Separator>}
              <SecondaryDescription>{topic.newsAgenda?.secondaryDescription}</SecondaryDescription>
            </>
          )}
        </DescriptionWrapper>
      </Contents>
    </Container>
  );
};

PlusNewsAgendaRightHead.displayName = "PlusNewsAgendaRightHead";
